<template>
  <v-dialog v-model="addAgeProofPrompt" max-width="650px" persistent>
    <v-card elevation="10" class="premium-card">
      <!-- Header -->
      <div class="header-gradient py-4 px-6">
        <div class="d-flex justify-space-between align-center">
          <div class="d-flex align-center">
            <v-avatar size="42" color="rgba(255,255,255,0.15)" class="mr-3">
              <v-icon color="white">mdi-account-check</v-icon>
            </v-avatar>
            <div>
              <h3 class="header-title mb-1">{{ pageDescription }}</h3>
              <p class="header-subtitle mb-0">
                Verify the age proof document for this nomination
              </p>
            </div>
          </div>

          <div class="header-bar"></div>

          <v-btn icon class="close-btn" @click="closePrompt">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <!-- Content -->
      <v-card-text class="pa-6">
        <!-- Candidate Info -->
        <transition name="fade-slide">
          <div class="candidate-info mb-5 card-block" v-if="row">
            <div class="card-header d-flex align-center mb-3">
              <div class="card-accent mr-3"></div>
              <div class="d-flex align-center">
                <div class="section-icon-wrapper mr-3">
                  <v-icon size="20" color="deep-purple darken-2"
                    >mdi-account-details</v-icon
                  >
                </div>
                <h3 class="card-title font-weight-medium text-subtitle-1">
                  Candidate Information
                </h3>
              </div>
            </div>

            <div class="candidate-data px-3 py-2">
              <div class="d-flex align-center mb-2">
                <span class="data-label">Name:</span>
                <span class="data-value font-weight-medium">{{
                  row.MemberName || "Not Available"
                }}</span>
              </div>
              <div class="d-flex align-center">
                <span class="data-label">LO:</span>
                <span class="data-value font-weight-medium">{{
                  row.LomName || "Not Available"
                }}</span>
              </div>
            </div>
          </div>
        </transition>

        <!-- Age Proof Description -->
        <transition name="fade-slide" appear>
          <div
            v-if="row && row.AgeProofDescription"
            class="age-proof-desc-card mb-5 card-block"
          >
            <div class="card-header d-flex align-center mb-2">
              <div class="card-accent mr-3 accent-doc"></div>
              <div class="d-flex align-center">
                <div class="desc-icon-wrapper mr-3">
                  <v-icon size="22" color="deep-purple darken-2"
                    >mdi-file-document-edit</v-icon
                  >
                </div>
                <h3 class="card-title font-weight-medium text-subtitle-1 mb-0">
                  Age Proof Description
                </h3>
              </div>
            </div>
            <div class="desc-divider mb-2"></div>
            <div class="desc-content px-3 py-2">
              <span class="desc-text">{{ stripHtml(row.AgeProofDescription) }}</span>
            </div>
          </div>
        </transition>
      </v-card-text>

      <!-- Footer -->
      <v-divider class="mx-4"></v-divider>
      <v-card-actions class="px-6 py-4">
        <v-spacer></v-spacer>

        <v-btn
          color="grey darken-1"
            text
            class="px-4 mr-2 action-btn cancel-btn"
            :loading="cancelLoading"
            @click="closePrompt"
        >
          <v-icon left size="18">mdi-close-circle</v-icon>
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      valid: true,
      ElectionOfficerFlag: false,
      records: {},
      addAgeProofPrompt: true,
      cancelLoading: false,
      verifyLoading: false,
    };
  },
  methods: {
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideDialog", this.ResultFlag);
    },
    refreshPageData() {},
    stripHtml(html) {
      if (!html) return "";
      return html.replace(/<[^>]*>/g, "");
    },
    async onVerify() {
      if (!this.ElectionOfficerFlag) return;
      try {
        this.verifyLoading = true;
        // Call verification API if desired. For now simulate with timeout.
        await new Promise((res) => setTimeout(res, 700));
        // Emit hide with true to indicate change
        this.$emit("hideDialog", true);
        this.addAgeProofPrompt = false;
      } catch (err) {
        console.error(err);
        this.toast("error", "Verification failed, try again");
      } finally {
        this.verifyLoading = false;
      }
    },
  },
  mounted() {
    this.refreshPageData();
    const roleId = this.$session.get("RoleId") || "";
    this.RoleId = roleId;

    const ElectionOfficerFlag = this.$session.get("ElectionOfficerFlag") || "";
    this.ElectionOfficerFlag = ElectionOfficerFlag;
  },
};
</script>

<style scoped>
.premium-card { border-radius: 12px; overflow: hidden; }
.header-gradient { background: linear-gradient(90deg, #6a11cb, #2575fc); color: #fff; }
.header-title { margin: 0; color: #fff; font-weight: 700; }
.header-subtitle { opacity: 0.95; font-size: 0.9rem; }
.candidate-info { background: linear-gradient(180deg,#fff,#fbfbff); border-radius: 8px; padding: 12px; }
.data-label { min-width: 60px; color: #6b6f76; }
.data-value { color: #2c3e50; margin-left: 8px; }
.age-proof-desc-card { background: #fff; border-radius: 8px; padding: 12px; box-shadow: 0 6px 18px rgba(36,72,126,0.04); }
.desc-content { color: #444; }
.action-btn { transition: transform 160ms ease, box-shadow 160ms ease; }
.action-btn:hover:not(:disabled) { transform: translateY(-3px); box-shadow: 0 10px 30px rgba(0,0,0,0.08); }
.verify-btn { box-shadow: 0 6px 18px rgba(37,117,252,0.12); }
.cancel-btn { opacity: 0.95; }
.card-block { background: linear-gradient(180deg,#fff,#fbfbff); border-radius: 10px; padding: 8px; box-shadow: 0 6px 18px rgba(36,72,126,0.04); }
.card-header { padding: 8px 4px; align-items: center; }
.card-accent { width: 6px; height: 36px; border-radius: 4px; background: linear-gradient(180deg,#6a11cb,#2575fc); }
.card-accent.accent-doc { background: linear-gradient(180deg,#ff6a00,#ff8a00); }
.card-title { margin: 0; font-weight: 700; }
.fade-slide-enter-active, .fade-slide-leave-active { transition: all 300ms cubic-bezier(.2,.8,.2,1); }
.fade-slide-enter, .fade-slide-leave-to { opacity: 0; transform: translateY(10px); }
</style>
